module.exports = __webpack_public_path__ + "193be610ebaa180c13739d080fd911dd.svg";